import {useAppContext} from '../../utils/AppContext.js';
import logo from "../../assets/images/maze_logo.svg";

const Brand = () => {
    const {
        screenSize
    } = useAppContext();

    return (
        <div className={`brand-container${screenSize}`}>
            <img 
                className={`logo-image${screenSize}`}
                src={logo} 
                alt="Maze logo"
            />
            <span className={`copyright-text`}>© 2025 • Maze</span>
        </div>
    );

}

export default Brand;
